export default __webpack_public_path__ + "static/media/TNBGaming.332ff478.png";